module.exports = __webpack_public_path__ + "static/media/screenshot-3.ea7d6fca.png";